const DOCUMENT = 'TRANSFER_ASSOCIATE_';

const actions = {
  TOUCH: DOCUMENT + 'TOUCH',
  SHOW_MODAL: DOCUMENT + 'SHOW_MODAL',
  CLOSE_MODAL: DOCUMENT + 'CLOSE_MODAL',
  TOGGLE_ASSOCIATE_SELECT: DOCUMENT + 'TOGGLE_ASSOCIATE_SELECT',
  SET_STEP: DOCUMENT + 'SET_STEP',
  CREATE_FIND_ASSOCIATE_FORM: DOCUMENT + 'CREATE_FIND_ASSOCIATE_FORM',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  LOAD_ASSOCIATE_FORM_DATA_REQUEST: DOCUMENT + 'LOAD_ASSOCIATE_FORM_DATA_REQUEST',
  LOAD_ASSOCIATE_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_ASSOCIATE_FORM_DATA_SUCCESS',
  FIND_ASSOCIATE_REQUEST: DOCUMENT + 'FIND_ASSOCIATE_REQUEST',
  FIND_ASSOCIATE_SUCCESS: DOCUMENT + 'FIND_ASSOCIATE_SUCCESS',
  FIND_ASSOCIATE_ERROR: DOCUMENT + 'FIND_ASSOCIATE_ERROR',
  BEGIN_BACKGROUND_CHECK_REQUEST: DOCUMENT + 'BEGIN_BACKGROUND_CHECK_REQUEST',
  BEGIN_BACKGROUND_CHECK_SUCCESS: DOCUMENT + 'BEGIN_BACKGROUND_CHECK_SUCCESS',
  BEGIN_BACKGROUND_CHECK_FAIL: DOCUMENT + 'BEGIN_BACKGROUND_CHECK_FAIL',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  showModal: () => ({
    type: actions.SHOW_MODAL,
  }),

  closeModal: () => ({
    type: actions.CLOSE_MODAL,
  }),

  toggleAssociateSelect: data => ({
    type: actions.TOGGLE_ASSOCIATE_SELECT,
    payload: data,
  }),

  setStep: data => ({
    type: actions.SET_STEP,
    payload: data,
  }),

  createFindAssociateForm: () => ({
    type: actions.CREATE_FIND_ASSOCIATE_FORM,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  loadAssociateFormDataRequest: data => ({
    type: actions.LOAD_ASSOCIATE_FORM_DATA_REQUEST,
    payload: data,
  }),

  loadAssociateFormDataSuccess: data => ({
    type: actions.LOAD_ASSOCIATE_FORM_DATA_SUCCESS,
    payload: data,
  }),

  findAssociateRequest: data => ({
    type: actions.FIND_ASSOCIATE_REQUEST,
    payload: data,
  }),

  findAssociateSuccess: data => ({
    type: actions.FIND_ASSOCIATE_SUCCESS,
    payload: data,
  }),

  findAssociateError: data => ({
    type: actions.FIND_ASSOCIATE_ERROR,
    payload: data,
  }),

  beginBackgroundCheckRequest: data => ({
    type: actions.BEGIN_BACKGROUND_CHECK_REQUEST,
    payload: data,
  }),

  beginBackgroundCheckSuccess: data => ({
    type: actions.BEGIN_BACKGROUND_CHECK_SUCCESS,
    payload: data,
  }),

  beginBackgroundCheckFail: data => ({
    type: actions.BEGIN_BACKGROUND_CHECK_FAIL,
    payload: data,
  }),
};

export default actions;
